/**
 * Cross-Sell Offer System - JavaScript (Price-based)
 * ====================================================
 * + Converge tracking: Popup (Cross Sell), Cross Sell Added To Cart
 */

(function () {
    'use strict';

    var cartProductIds = [];
    var candidates = [];
    var currentCandidateIndex = -1;

    function addToCart(variantId, quantity, properties) {
        quantity = quantity || 1;
        properties = properties || {};
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: parseInt(variantId, 10),
                    quantity: quantity,
                    properties: properties
                }]
            })
        }).then(function(response) {
            if (!response.ok) throw new Error('Failed to add to cart');
            return response.json();
        });
    }

    function getCart() {
        return fetch('/cart.js', {
            headers: { 'Content-Type': 'application/json' }
        }).then(function(response) { return response.json(); });
    }

    function fetchCartProductIds() {
        return getCart().then(function(cart) {
            cartProductIds = cart.items.map(function(item) {
                return item.product_id;
            });
            return cartProductIds;
        });
    }

    function openMiniCart() {
        // Refresh cart sections, then open Dawn's cart drawer
        fetch('/?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' })
            .then(function(r) { return r.json(); })
            .then(function(sections) {
                // Update cart drawer
                if (sections['cart-drawer']) {
                    var cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                        var tmp = document.createElement('div');
                        tmp.innerHTML = sections['cart-drawer'];
                        var newDrawer = tmp.querySelector('cart-drawer');
                        if (newDrawer) {
                            cartDrawer.innerHTML = newDrawer.innerHTML;
                            cartDrawer.classList.remove('is-empty');
                        }
                    }
                }
                // Update cart bubble (item count badge)
                if (sections['cart-icon-bubble']) {
                    var bubble = document.getElementById('cart-icon-bubble');
                    if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
                }
            })
            .catch(function() {})
            .finally(function() {
                // Open Dawn's cart drawer
                setTimeout(function() {
                    var cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer && typeof cartDrawer.open === 'function') {
                        cartDrawer.open();
                        if(typeof cartDrawer.init === 'function'){
                            cartDrawer.init();
                        }
                    } else {
                        // Fallback: click the cart icon
                        var cartIcon = document.querySelector('a[href="/cart"], #cart-icon-bubble');
                        if (cartIcon) cartIcon.click();
                    }
                }, 100);
            });
    }

    function loadCandidates() {
        var el = document.getElementById('cross-sell-candidates');
        if (!el) return [];
        try {
            var raw = JSON.parse(el.textContent);
            return raw.filter(function(item) { return item !== null; });
        } catch (e) {
            console.error('Failed to parse cross-sell candidates:', e);
            return [];
        }
    }

    function findNextEligible(startIndex) {
        startIndex = startIndex || 0;
        for (var i = startIndex; i < candidates.length; i++) {
            var c = candidates[i];
            if (!c.available || !c.variantAvailable) continue;
            if (cartProductIds.indexOf(c.productId) !== -1) continue;
            if (c.locations && c.locations.length > 0) {
                var hasPdp = false;
                for (var j = 0; j < c.locations.length; j++) {
                    if (c.locations[j] === 'pdp') { hasPdp = true; break; }
                }
                if (!hasPdp) continue;
            }
            return i;
        }
        return -1;
    }

    function formatMoney(cents) {
        var amount = (cents / 100).toFixed(2);
        var el = document.querySelector('.cross-sell-popup__price-current');
        if (el) {
            var text = el.textContent;
            if (text.indexOf(',') > -1) {
                amount = amount.replace('.', ',');
            }
        }
        return amount;
    }

    function renderCandidate(index) {
        var c = candidates[index];
        console.log('candidate:', c);
        if (!c) return false;

        var container = document.getElementById('cross-sell-offer-container');
        var heading = document.getElementById('cross-sell-offer-heading');
        var image = document.getElementById('cross-sell-offer-image');
        var title = document.getElementById('cross-sell-offer-title');
        var description = document.getElementById('cross-sell-offer-description');
        var pricing = document.getElementById('cross-sell-offer-pricing');
        var addBtn = document.getElementById('cross-sell-offer-add-btn');
        var closeBtn = document.getElementById('cross-sell-offer-close-btn');
        var advice = document.getElementById('cross-sell-offer-advice');

        if (!container) return false;

        heading.innerHTML = c.heading;
        image.src = c.image;
        image.alt = c.imageAlt;
        title.textContent = c.title;
        description.textContent = c.oneliner;

        var originalPrice = c.price;
        var crossSellPrice = c.crossSellPrice || 0;
        var crossSellPriceCents = Math.round(crossSellPrice * 100);

        if (crossSellPrice > 0 && crossSellPriceCents < originalPrice) {
            var savingsPercent = Math.round((originalPrice - crossSellPriceCents) / originalPrice * 100);
            pricing.innerHTML =
                '<span class="cross-sell-offer__price-original">' + formatMoney(originalPrice) + '</span> ' +
                '<span class="cross-sell-offer__price-sale">' + formatMoney(crossSellPriceCents) + '</span> ' +
                '<span class="cross-sell-offer__price-badge">-' + savingsPercent + '%</span>';
        } else {
            pricing.innerHTML =
                '<span class="cross-sell-offer__price">' + formatMoney(originalPrice) + '</span>';
        }

        addBtn.setAttribute('data-variant-id', c.variantId);
        addBtn.setAttribute('data-cross-sell-price', crossSellPrice);
        addBtn.textContent = window.myTranslations.addToCart;
        addBtn.classList.remove('cross-sell-offer__add-btn--added', 'cross-sell-offer__add-btn--loading');
        closeBtn.textContent = window.myTranslations.closeBtn;
        console.log(closeBtn)
        console.log(window.myTranslations.closeBtn)

        var slotNumber = index + 1;
        var adviceBlock = document.querySelector('#cross-sell-advice-blocks [data-advice-for="' + slotNumber + '"]');
        if (adviceBlock) {
            advice.innerHTML = adviceBlock.innerHTML;
            advice.style.display = '';
        } else {
            advice.innerHTML = '';
            advice.style.display = 'none';
        }

        container.style.display = '';
        currentCandidateIndex = index;
        return true;
    }

    function formatMoneyFromCents(cents) {
        var amount = (cents / 100).toFixed(2);
        var el = document.querySelector('.cross-sell-popup__price-current, .price');
        if (el && el.textContent.indexOf(',') > -1) amount = amount.replace('.', ',');
        var symbol = '\u20ac';
        var priceText = el ? el.textContent.trim() : '';
        var symMatch = priceText.match(/^[^\d\s]+/);
        if (symMatch) symbol = symMatch[0];
        return symbol + amount;
    }

    function updateAddedHeader(ctx) {
        if (!ctx) return;
        var pricingEl = document.querySelector('.cross-sell-popup__added-pricing');
        if (!pricingEl) return;
        var priceEl   = pricingEl.querySelector('.cross-sell-popup__price-current');
        var compareEl = pricingEl.querySelector('.cross-sell-popup__price-original');
        var badgeEl   = pricingEl.querySelector('.cross-sell-popup__price-badge');
        if (priceEl && ctx.totalCents) {
            priceEl.textContent = '\u20ac' + (ctx.totalCents / 100).toFixed(2).replace('.', ',');
        }
        if (ctx.compareCents && ctx.compareCents > ctx.totalCents) {
            var pct = Math.round((ctx.compareCents - ctx.totalCents) / ctx.compareCents * 100);
            if (compareEl) {
                compareEl.textContent = '\u20ac' + (ctx.compareCents / 100).toFixed(2).replace('.', ',');
                compareEl.style.display = '';
            } else {
                var newCompare = document.createElement('span');
                newCompare.className = 'cross-sell-popup__price-original';
                newCompare.textContent = '\u20ac' + (ctx.compareCents / 100).toFixed(2).replace('.', ',');
                pricingEl.insertBefore(newCompare, priceEl);
            }
            if (badgeEl) {
                badgeEl.textContent = '-' + pct + '%';
                badgeEl.style.display = '';
            } else {
                var newBadge = document.createElement('span');
                newBadge.className = 'cross-sell-popup__price-badge';
                newBadge.textContent = '-' + pct + '%';
                pricingEl.appendChild(newBadge);
            }
        }
        if (ctx.qty && ctx.qty > 1) {
            var titleEl = document.querySelector('.cross-sell-popup__added-title');
            if (titleEl) {
                var existingQty = document.querySelector('.cross-sell-injected-qty');
                if (!existingQty) {
                    var qtyPill = document.createElement('span');
                    qtyPill.className = 'cross-sell-injected-qty';
                    qtyPill.style.cssText = 'display:inline-flex;align-items:center;background:#f0f0f0;color:#333;font-size:11px;font-weight:700;padding:2px 8px;border-radius:20px;margin-right:6px;vertical-align:middle;';
                    qtyPill.textContent = ctx.qty + 'x';
                    titleEl.insertBefore(qtyPill, titleEl.firstChild);
                } else {
                    existingQty.textContent = ctx.qty + 'x';
                }
            }
        }
    }

    function showPopupWithEligible(addedContext) {
        var popup = document.getElementById('cross-sell-popup');
        if (!popup) return Promise.resolve(false);

        return fetchCartProductIds().then(function() {
            var index = findNextEligible(0);
            if (index === -1) return false;

            renderCandidate(index);
            if (addedContext) updateAddedHeader(addedContext);

            popup.dataset.hasCrossSell = 'true';
            popup.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';

            /* ── Converge: Track Popup (Cross Sell) impression ── */
            if (typeof CvgTrack !== 'undefined') {
                var c = candidates[currentCandidateIndex];
                CvgTrack.track('Popup (Cross Sell)', {
                    action: 'impression',
                    atc_location: 'product_page_cross-sell_popup',
                    offered_product_id: c ? String(c.productId) : '',
                    offered_product_name: c ? c.title : '',
                    offered_variant_id: c ? String(c.variantId) : '',
                    cross_sell_price: c ? (c.crossSellPrice || 0) : 0,
                    source_product: document.title.split(' – ')[0] || ''
                });
            }
            /* ── End Converge ──────────────────────────────────── */

            return true;
        });
    }

    function closePopup(closeMethod) {
        var popup = document.getElementById('cross-sell-popup');
        if (!popup) return;
        var wasOpen = popup.getAttribute('aria-hidden') === 'false';

        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        /* ── Converge: Track Popup (Cross Sell) close ──────── */
        if (wasOpen && closeMethod && typeof CvgTrack !== 'undefined') {
            CvgTrack.track('Popup (Cross Sell)', {
                action: 'close',
                atc_location: 'product_page_cross-sell_popup',
                close_method: closeMethod,
                offered_product_id: candidates[currentCandidateIndex] ? String(candidates[currentCandidateIndex].productId) : '',
                offered_product_name: candidates[currentCandidateIndex] ? candidates[currentCandidateIndex].title : ''
            });
        }
        /* ── End Converge ──────────────────────────────────── */

        openMiniCart();
    }

    function handleCrossSellAdd(e) {
        var btn = e.currentTarget;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.classList.contains('cross-sell-offer__add-btn--loading')) return;

        btn.classList.add('cross-sell-offer__add-btn--loading');
        btn.textContent = '...';

        var crossSellPrice = btn.getAttribute('data-cross-sell-price');
        if (!crossSellPrice && candidates[currentCandidateIndex]) {
            crossSellPrice = candidates[currentCandidateIndex].crossSellPrice || 0;
        }

        // Determine atc_location based on context
        var isPopup = btn.closest('#cross-sell-popup');
        var atcLocation = isPopup ? 'product_page_cross-sell_popup' : 'minicart_product_cross-sell';

        /* ── Converge: Enrich ATC + write cookie ──────────── */
        window.__cvg_atc_handled = true;
        if (typeof CvgTrack !== 'undefined') {
            CvgTrack.set({ atc_location: atcLocation });
            CvgTrack.setAtcMap(parseInt(variantId, 10), atcLocation, null);
        }
        /* ── End Converge ──────────────────────────────────── */

        addToCart(variantId, 1, {
            '_cross_sell': 'true',
            '_cross_sell_price': String(crossSellPrice || 0)
        })
            .then(function() {
                btn.classList.remove('cross-sell-offer__add-btn--loading');
                btn.classList.add('cross-sell-offer__add-btn--added');
                btn.textContent = '\u2713 ' + window.myTranslations.addedToCart;

                /* ── Converge: Track Cross Sell Added To Cart ────── */
                if (typeof CvgTrack !== 'undefined') {
                    var c = candidates[currentCandidateIndex];
                    CvgTrack.track('Added To Cart (Cross Sell)', {
                        product_id: c ? String(c.productId) : String(variantId),
                        variant_id: String(variantId),
                        name: c ? c.title : '',
                        price: crossSellPrice ? parseFloat(crossSellPrice) : 0,
                        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
                        quantity: 1,
                        atc_location: atcLocation,
                        source_product: document.title.split(' – ')[0] || ''
                    });
                }
                /* ── End Converge ────────────────────────────────── */

                if (isPopup) {
                    setTimeout(function() {
                        closePopupSilently();
                        openMiniCart();
                    }, 800);
                } else {
                    // Minicart cross-sell — refresh drawer
                    setTimeout(function() { openMiniCart(); }, 800);
                }
            })
            .catch(function(error) {
                console.error('Cross-sell add failed:', error);
                btn.classList.remove('cross-sell-offer__add-btn--loading');
                btn.textContent = window.myTranslations.addToCart;
            });
    }

    function closePopupSilently() {
        var popup = document.getElementById('cross-sell-popup');
        if (!popup) return;
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    function updateCartCount() {
        getCart().then(function(cart) {
            var countEls = document.querySelectorAll(
                '.cart-count, [data-cart-count], .cart-count-bubble span, .header__cart-count, .cart-bubble__text-count'
            );
            countEls.forEach(function(el) { el.textContent = cart.item_count; });
            document.querySelectorAll('cart-icon').forEach(function(icon) {
                icon.classList.add('header-actions__cart-icon--has-cart');
            });
        });
    }

    function initPopup() {
        var popup = document.getElementById('cross-sell-popup');
        if (!popup) return;

        // Close button + "No thanks" — pass close method
        popup.querySelectorAll('[data-cross-sell-popup-close]').forEach(function(el) {
            el.addEventListener('click', function() {
                var isOverlay = el.classList.contains('cross-sell-popup__overlay');
                closePopup(isOverlay ? 'overlay_click' : 'close_btn');
            });
        });

        // ESC key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
                closePopup('esc_key');
            }
        });

        // ATC button inside popup
        popup.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-cross-sell-add]');
            if (btn) handleCrossSellAdd({ currentTarget: btn });
        });
    }

    function initCartCrossSell() {
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-cross-sell-add]');
            if (!btn) return;
            if (btn.closest('#cross-sell-popup')) return;
            handleCrossSellAdd({ currentTarget: btn });
        });
    }

    window.crossSellShowPopup = function(addedContext) {
    // A/B gate (GrowthBook): only run when explicitly enabled.
    // If disabled or unset, return false so the caller falls through
    // to the normal Dawn cart drawer (control experience).
    if (!window.__crossSellEnabled) {
      return Promise.resolve(false);
    }
    return showPopupWithEligible(addedContext || null);
  };

    function init() {
        candidates = loadCandidates();
        initPopup();
        initCartCrossSell();
        fetchCartProductIds();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
